import * as React from 'react';
import cn from 'classnames';
import ButtonBase, { ButtonBaseProps } from '@mui/material/ButtonBase';

import { ButtonSize, ButtonVariant } from './types';
import { useTheme } from '../theme';

const successIcon = (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M9.00039 16.1996L4.80039 11.9996L3.40039 13.3996L9.00039 18.9996L21.0004 6.99961L19.6004 5.59961L9.00039 16.1996Z"
			fill="white"
		/>
	</svg>
);

interface OwnProps {
	/**
	 * Style of the button.
	 */
	variant?: ButtonVariant;

	/**
	 * Size of the button.
	 */
	size?: ButtonSize;

	/**
	 * Show loading spinner.
	 */
	isLoading?: boolean;

	/**
	 * Show success marker.
	 */
	isSuccess?: boolean;

	/**
	 * Convert button into a link.
	 */
	href?: string;

	target?: string;
}

export type Props = OwnProps & ButtonBaseProps;

/**
 * @deprecated
 */
export const Button: React.FunctionComponent<Props> = props => {
	const {
		variant = 'common',
		size = 'common',
		isLoading = false,
		isSuccess = false,
		children,
		className,
		...rest
	} = props;
	const { Button: css } = useTheme('Button');

	if (isLoading || isSuccess) {
		return (
			<div
				className={cn(
					{
						[css.loader]: isLoading,
						[css.loader_outline]: variant === 'outline',
						[css.success]: isSuccess
					},
					className
				)}
			>
				{isLoading && <div className={css.loader__spinner} />}
				{isSuccess && successIcon}
			</div>
		);
	}

	return (
		<ButtonBase
			className={cn(
				css.button,
				{
					[css.button_outline]: variant === 'outline',
					[css.button_flat]: variant === 'flat',
					[css.button_text]: variant === 'text',
					[css.button_small]: size === 'small',
					[css.button_large]: size === 'large'
				},
				className
			)}
			{...rest}
		>
			{children}
		</ButtonBase>
	);
};

Button.displayName = 'Button';

export default Button;
